import { TCustomTooltipSides } from './types';
import styles from './Tooltip.scss';

export const TOOLTIP_SIDE_CLASS_MAP = {
  [TCustomTooltipSides.left]:
    styles['descriptionIsLeftSide'],
  [TCustomTooltipSides.right]:
    styles['descriptionIsRightSide']
};
